import { ImageProps } from '../Image';

export interface ThumbnailImageProps extends ImageProps {}

export * from '../Image/types';
